import { groupByOptions } from 'app/containers/MainDashboard/consts.js';
import { GroupByOption } from 'app/containers/MainDashboard/panels/MtdCostBreakdown/types'; // Ensure the GroupByOption type is imported
import { AWS_GROUP_BY_LOV, GROUP_BY_LOV, GroupByLovToAttributes } from 'usage/constants/costAndUsageConstants.js';
import { GCPCommonFieldLabels } from 'shared/constants/gcpConstants.js';
import LabelCoordinator from 'shared/modules/labelCoordinator.js';
import { CLOUD_TYPE_IDS } from 'users/constants/usersConstants.js';

interface OverrideAccount {
  cloudTypeId?: number;
}

export const getGroupOptions = (usersStore, overrideAccount: OverrideAccount | null = null): GroupByOption[] => {
  const {
    isCurrentAccountAllAccounts,
    isCurrentAccountMulticloud,
    currDispUserCloudAccountType: currentCloudType,
    isCurrentUserReCustomer: isReseller,
    isCurrentUserReseller: isMSP,
    rootStore,
  } = usersStore;

  const isAllAccount = overrideAccount ? usersStore.isAccountAllAccounts(overrideAccount) : isCurrentAccountAllAccounts;
  const isMultiCloudAccount = overrideAccount
    ? overrideAccount?.cloudTypeId === CLOUD_TYPE_IDS.MULTI
    : isCurrentAccountMulticloud;

  let cloudType = currentCloudType;
  if (overrideAccount) {
    cloudType = overrideAccount?.cloudTypeId;
  }
  const groupsOptions = groupByOptions[cloudType] || [];
  const groups = [...groupsOptions];

  if (isAllAccount && !groups.includes(GROUP_BY_LOV.PAYER_ACCOUNT)) {
    groups.push(GROUP_BY_LOV.PAYER_ACCOUNT);
  } else if (!isAllAccount && !isMultiCloudAccount && groups.includes(GROUP_BY_LOV.PAYER_ACCOUNT)) {
    groups.splice(groups.indexOf(GROUP_BY_LOV.PAYER_ACCOUNT), 1);
  }

  if (isReseller && !rootStore.appStore.isKeyCloakManagement) {
    const divisionIndex = groups.indexOf(AWS_GROUP_BY_LOV.BY_DIVISION);
    if (divisionIndex !== -1) {
      groups.splice(divisionIndex, 1);
    }
  }
  if (rootStore.appStore.isKeyCloakManagement && isMSP) {
    groups.push(AWS_GROUP_BY_LOV.BY_COST_CENTER);
  }

  return groups.map((group) => ({
    value: GroupByLovToAttributes.get(group) ?? null,
    label:
      currentCloudType === CLOUD_TYPE_IDS.GCP && GCPCommonFieldLabels.get(group)
        ? GCPCommonFieldLabels.get(group)!
        : LabelCoordinator.getFieldLabel(group) || '',
  }));
};
